var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { CollapsibleListData_InitialExpandedItems, Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const collapsibleListConverter = {
  toTiptap: {
    types: [Node_Type.COLLAPSIBLE_LIST],
    convert: (node, visit) => ({
      type: Node_Type.COLLAPSIBLE_LIST,
      attrs: __spreadProps(__spreadValues({}, node.collapsibleListData), {
        id: node.id
      }),
      content: node.nodes.map((collapsibleItem, index) => {
        const expandState = node.collapsibleListData.initialExpandedItems;
        return {
          type: Node_Type.COLLAPSIBLE_ITEM,
          attrs: {
            id: collapsibleItem.id,
            isExpanded: expandState === CollapsibleListData_InitialExpandedItems.ALL || index === 0 && expandState === CollapsibleListData_InitialExpandedItems.FIRST,
            expandOnlyOne: node.collapsibleListData.expandOnlyOne
          },
          content: visit(collapsibleItem)
        };
      })
    })
  },
  fromTiptap: {
    types: [Node_Type.COLLAPSIBLE_LIST],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const _a = attrs, { id } = _a, data = __objRest(_a, ["id"]);
      return {
        type: Node_Type.COLLAPSIBLE_LIST,
        id,
        nodes: visit(node),
        collapsibleListData: __spreadValues({}, data)
      };
    }
  }
};
const collapsibleItemConverter = {
  toTiptap: {
    types: [Node_Type.COLLAPSIBLE_ITEM],
    convert: (node, visit) => ({
      type: Node_Type.COLLAPSIBLE_ITEM,
      attrs: {
        id: node.id
      },
      content: visit(node)
    })
  },
  fromTiptap: {
    types: [Node_Type.COLLAPSIBLE_ITEM],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.COLLAPSIBLE_ITEM,
        id,
        nodes: visit(node)
      };
    }
  }
};
const collapsibleItemTitleConverter = {
  toTiptap: {
    types: [Node_Type.COLLAPSIBLE_ITEM_TITLE],
    convert: (node, visit) => ({
      type: Node_Type.COLLAPSIBLE_ITEM_TITLE,
      attrs: {
        id: node.id
      },
      content: visit(node)
    })
  },
  fromTiptap: {
    types: [Node_Type.COLLAPSIBLE_ITEM_TITLE],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.COLLAPSIBLE_ITEM_TITLE,
        id,
        nodes: visit(node)
      };
    }
  }
};
const collapsibleItemBodyConverter = {
  toTiptap: {
    types: [Node_Type.COLLAPSIBLE_ITEM_BODY],
    convert: (node, visit) => ({
      type: Node_Type.COLLAPSIBLE_ITEM_BODY,
      attrs: {
        id: node.id
      },
      content: visit(node)
    })
  },
  fromTiptap: {
    types: [Node_Type.COLLAPSIBLE_ITEM_BODY],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.COLLAPSIBLE_ITEM_BODY,
        id,
        nodes: visit(node)
      };
    }
  }
};
export {
  collapsibleItemBodyConverter,
  collapsibleItemConverter,
  collapsibleItemTitleConverter,
  collapsibleListConverter
};
//# sourceMappingURL=collapsible-list-converters.js.map
